import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'web-common'
import { PuzzlesListingCards } from '../../../user-registration/breach/components/PuzzlesBreach/PuzzlesListingCards'
import {
    PuzzleListingBanner,
    PuzzleListingContainer,
    PuzzleListingDescription,
    PuzzleListingItem,
} from './PuzzleListing.styled'
const crossword = require('./assets/crossword.png')
const sudoku = require('./assets/sudoku.png')
const target = require('./assets/target.png')
const wordSearch = require('./assets/word_search.png')
const leftBgImage = require('./assets/banner-left-asset.png')
const rightBgImage = require('./assets/banner-right-asset.png')
const leftBgImageMobile = require('./assets/mob-left.png')
const rightBgImageMobile = require('./assets/mob-right.png')

export function PuzzleListing() {
    const appState = useSelector((state: AppState) => state)
    const renditionType = appState.render.renditionType

    return (
        <div>
            {renditionType !== 'app' && (
                <PuzzleListingDescription>
                    Stay sharp and challenge yourself with daily puzzles from
                    The West.
                </PuzzleListingDescription>
            )}
            <PuzzleBanner renditionType={renditionType} />
            <PuzzleListingContainer>
                <PuzzlesListingCards disabled={false} />
            </PuzzleListingContainer>
        </div>
    )
}

export function PuzzleBanner(props: { renditionType?: string }) {
    const [isMobile, setIsMobile] = useState(Boolean)
    useEffect(() => {
        window.innerWidth < 660 && setIsMobile(true)
        window.addEventListener('resize', function () {
            if (window.innerWidth < 660) {
                setIsMobile(true)
            } else {
                setIsMobile(false)
            }
        })
    })
    return (
        <>
            <PuzzleListingBanner
                leftImage={isMobile ? leftBgImageMobile : leftBgImage}
                rightImage={isMobile ? rightBgImageMobile : rightBgImage}
                isApp={props.renditionType === 'app'}
            >
                <p>
                    New puzzles <span>every day.</span>
                </p>
            </PuzzleListingBanner>
        </>
    )
}
